// extracted by mini-css-extract-plugin
module.exports = {"QuickNav":"QuickNav-module--QuickNav--3KpYc","QuickNav_Trigger":"QuickNav-module--QuickNav_Trigger--3_9Ez","QuickNav_Anchors":"QuickNav-module--QuickNav_Anchors--mBv4a"};